import CollectionFilterBrandsDialog from "./collection-filter-pc-brands-dialog";

const CollectionFilterBrands = (el, sectionParams, onChangeFilterParams) => {
  let filterParams = [];
  let collectionVendor = null;
  let dialog = null;

  const initialize = () => {
    el.querySelector(".fs-title-row button").addEventListener("click", () => {
      if (sectionParams.collection.handle != "all") {
        location.href = "/collections/all" + location.search;
        return;
      }
      const newFilterParams = filterParams.filter((kv) => kv.key != "vendor");
      onChangeFilterParams(newFilterParams);
    });
    el.querySelector(".fs-row").addEventListener("click", () => {
      let vendors = filterParams.filter((kv) => kv.key == "vendor").map((kv) => kv.value);
      if (collectionVendor && !vendors.includes(collectionVendor)) {
        vendors.push(collectionVendor);
      }
      dialog.show(vendors, (newVendors) => {
        if (collectionVendor && newVendors.includes(collectionVendor) && newVendors.length <= 1) {
          return;
        }
        if (newVendors) {
          const newFilterParams = filterParams.filter((kv) => kv.key != "vendor");
          const newVendorParams = newVendors.map((v) => {
            return { key: "vendor", value: v };
          });
          onChangeFilterParams([...newFilterParams, ...newVendorParams]);
        }
      });
    });

    if (sectionParams.collection.handle != "all") {
      collectionVendor = sectionParams.collection.title;
    }

    const dialogEl = el.querySelector(".fs-collection-filter-brands-dialog");
    dialog = CollectionFilterBrandsDialog(dialogEl);
  };

  const setFilterParams = (newFilterParams, sectionParams) => {
    filterParams = newFilterParams;

    let vendors = [];
    if (collectionVendor && collectionVendor != "familysale2025") {
      vendors.push(collectionVendor);
    }
    vendors = vendors.concat(
      filterParams.filter((kv) => kv.key == "vendor" && kv.value != collectionVendor).map((kv) => kv.value),
    );
    if (vendors.length <= 0) {
      vendors = ["指定なし"];
    }
    el.querySelector(".fs-row label").innerText = vendors.join(", ");
  };

  initialize();

  return {
    setFilterParams: setFilterParams,
  };
};

export default CollectionFilterBrands;
